export class GetCUPCurAssistPlanDetailInput{
    Years: string = ''
    DeptNo: string = ''
    TeamNo: string = ''
    AcadCourseNo: string = ''
    OrderBy: string = ''
    PlanID: string = ''
}